module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_08.372169f8.png";